export default __webpack_public_path__ + "static/media/Women_in_Tech.f28ebee2.png";